import { promiseDeprecated } from './constants';
var runtimeVar = {
  runtimePromiseDeprecatedFlag: promiseDeprecated,
  runtimeDepsModelCollectedMap: new Map(),
  runtimeRacePromiseContext: '',
  runtimeUpdateOrigin: null,
  runtimeUpdateOriginId: null,
  runtimeBeginOriginId: null,
  runtimeBindType: 0,
  runtimeListenType: 0,
  runtimeRacePromisesCollectedSet: null,
  runtimeNoPreTreat: false,
  runtimeFromDerived: false
};
export default runtimeVar;